export default [
  {
    path: '/engineers',
    name: 'engineers',
    component: () => import('@/views/engineers-setup/Engineers.vue'),
  },
  {
    path: '/engineers/details/:id',
    name: 'info-details-engineers',
    component: () => import('@/views/engineers-setup/control-engineers/EngineersInfo.vue'),
    meta: {
      title: 'Details Engineers',
      requiresAuth: true,
      pageTitle: 'Engineers',
      breadcrumb: [
        {
          text: 'Engineers',
          to: '/engineers',
        },
        {
          text: 'show',
          active: true,
        },
      ],
    },
  },
  {
    path: '/engineers/add',
    name: 'add-engineers',
    component: () => import('@/views/engineers-setup/control-engineers/AddEditEngineers.vue'),
    meta: {
      title: 'Add Engineers ',
      requiresAuth: true,
      action: 'create',
      resource: 'Engineers',
      pageTitle: 'Engineers',
      breadcrumb: [
        {
          text: 'Engineers',
          to: '/engineers',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/engineers/edit/:id',
    name: 'edit-engineers',
    component: () => import('@/views/engineers-setup/control-engineers/AddEditEngineers.vue'),
    meta: {
      title: 'Edit Engineers',
      requiresAuth: true,
      pageTitle: 'Engineers',
      breadcrumb: [
        {
          text: 'Engineers',
          to: '/engineers',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/training/:id',
    name: 'show-user-training',
    component: () => import('@/views/engineers-setup/Training.vue'),
    meta: {
      title: 'Engineers training ',
      requiresAuth: true,
      action: 'browes',
      resource: 'training',
      pageTitle: 'Engineers training',
      breadcrumb: [
        {
          text: 'Engineers',
          to: '/engineers',
        },
        {
          text: 'Engineers Training',
          active: true,
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/engineers/certificate/:id',
    name: 'certificates-status-work',
    component: () => import(
      '@/views/engineers-setup/control-engineers/StatusAndWorkCertificates.vue'
    ),
  },
]
